var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFormatZip = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13a.5.5 0 0 1 .492.41l.008.09v5a.5.5 0 0 1-.992.09L10 18.5v-5a.5.5 0 0 1 .5-.5ZM14.75 13a1.75 1.75 0 0 1 .143 3.494l-.143.006-.751-.001.001 2a.5.5 0 0 1-.41.492l-.09.008a.5.5 0 0 1-.492-.41l-.008-.09V13.5a.5.5 0 0 1 .41-.492L13.5 13h1.25Zm-.751 2.499.751.001a.75.75 0 0 0 .102-1.493L14.75 14l-.751-.001v1.5ZM7.5 13a.5.5 0 0 1 .478.646l-.03.078-2.139 4.275L7.5 18a.5.5 0 0 1 .492.41L8 18.5a.5.5 0 0 1-.41.492L7.5 19H5a.5.5 0 0 1-.478-.646l.03-.078L6.692 14 5 14a.5.5 0 0 1-.492-.41L4.5 13.5a.5.5 0 0 1 .41-.492L5 13h2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5-.001H.5a.5.5 0 0 0-.5.5v23a.5.5 0 0 0 .5.5h19a.5.5 0 0 0 .5-.5v-17a.5.5 0 0 0-.146-.354l-6-6A.5.5 0 0 0 13.5 0Zm-.208.999 5.707 5.707v16.293h-18v-22h12.293Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5-.001a.5.5 0 0 1 .492.41L14 .5l-.001 5.499 5.501.001a.5.5 0 0 1 .492.41L20 6.5a.5.5 0 0 1-.41.492l-.09.008h-6a.5.5 0 0 1-.492-.41L13 6.499v-6a.5.5 0 0 1 .5-.5Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFormatZip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/format-zip.d2b8a1feb1a9dfd3dab6a60f3684a19d.svg";